<template>
    <div class="service-options__manufacturer-update-row">
        <div class="service-options__manufacturer-update-row-left">
            <span class="service-options__manufacturer-update-label">{{ record.label }}</span>
            <span class="service-options__manufacturer-update-code">({{ record.code }})</span>
        </div>
        <div class="service-options__manufacturer-update-row-right">
            <label class="service-options__switch">
                <input
                    type="checkbox"
                    class="service-options__switch-input"
                    :checked="isSelectedInStore"
                    @change="onChange"
                    :aria-checked="isSelectedInStore.toString()"
                />
                <span class="service-options__slider"></span>
                <span class="service-options__yes">Yes</span>
                <span class="service-options__no">No</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ManufacturerUpdateRecord',
    props: {
        record: { type: Object, required: true },
        selected: { type: Array, required: true },
    },
    computed: {
        isSelectedInStore() {
            return this.selected.findIndex(u => u.code === this.record.code) >= 0;
        }
    },
    methods: {
        onChange(e) {
            if (this.isSelectedInStore) {
                // Attempting to deselect: keep it checked visually and request confirmation
                e.target.checked = true;
                this.$emit('attempt-deselect', this.record);
                return;
            }
            // Selecting
            this.$emit('select', this.record);
        }
    }
};
</script>

<style lang="scss" scoped>
.service-options__manufacturer-update-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #e2e6ea;
    gap: 1rem;

    &:last-child { border-bottom: 0; }
}

.service-options__manufacturer-update-row-left {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0; // allow text truncation
}

.service-options__manufacturer-update-label {
    font-weight: 500;
    color: #222;
    line-height: 1.2;
    word-break: break-word;
}

.service-options__manufacturer-update-code {
    font-size: 0.75rem;
    color: #6c757d;
    letter-spacing: .5px;
    text-transform: uppercase;
    margin-top: 2px;
}

.service-options__manufacturer-update-row-right { flex: 0 0 auto; display: flex; align-items: center; }
.service-options__manufacturer-update-row-right .service-options__switch { margin-left: .5rem; }

@media (max-width: 640px) {
    .service-options__manufacturer-update-row { flex-direction: column; align-items: stretch; }
    .service-options__manufacturer-update-row-right { justify-content: flex-end; }
}
</style>
